import { render, staticRenderFns } from "./AgoraVideoCall.vue?vue&type=template&id=a9ce0ac6&scoped=true&"
import script from "./AgoraVideoCall.vue?vue&type=script&lang=js&"
export * from "./AgoraVideoCall.vue?vue&type=script&lang=js&"
import style0 from "./AgoraVideoCall.vue?vue&type=style&index=0&id=a9ce0ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ce0ac6",
  null
  
)

export default component.exports